import * as React from 'react';

interface IDirectoryListing
{
  name: string;
  phone: string;
  primaryCategory: string;
  email: string;
  
  companyName: string;
  companyAddress1: string;
  companyAddress2: string;
  companyCity: string;
  companyState: string;
  companyZipCode: string;
  companyWebsite: string;

  bio?: string;
  thumbnail?: string;
}

class DirectoryListing extends React.Component<IDirectoryListing, any>{
  constructor(props)
  {
    super(props);
  }
  
  render()
  {
    var profileImageStyles = { backgroundImage: `url(${this.props.thumbnail})`}

    return (
      <section className="affiliate-listing-card">
        <div className="affiliate-member-profile">
          <div className="affiliate-member-profile-info">

            <div className="affiliate-member-profile-snapshot">

              {(this.props.thumbnail !== null && this.props.thumbnail !== "") ? (
                <div className="affiliate-member-profile-thumb" style={profileImageStyles}></div>
              ) : (
                <div className="affiliate-member-profile-thumb affiliate-member-profile-thumb-placeholder">
                  <svg className="svg-icon" aria-hidden="true" focusable="false">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-member"></use>
                  </svg>
                </div>
              )}

              <div className="affiliate-member-profile-name">
                <h4>{this.props.name}</h4>
                {(this.props.phone !== null) && (
                  <a href={'tel:' + this.props.phone}>{this.props.phone}</a>
                )}
              </div>

            </div>

            {this.props.primaryCategory !== null && 
              <span className="affiliate-member-profile-category">{this.props.primaryCategory}</span>}
          </div>

          <div className="affiliate-member-profile-contact">
            <div className="affiliate-member-company">
              {this.props.companyName}
            </div>
            
              <div>{this.props.companyAddress1}</div>
              {/*<div>{this.props.companyAddress2 != "" ? this.props.companyAddress2 : null}</div>*/}
              <div>{this.props.companyCity}, {this.props.companyState} {this.props.companyZipCode}</div>
            
              <div><a href={'mailto: ' + this.props.email} className="affiliate-member-email">{this.props.email}</a></div>

              {(this.props.companyWebsite !== null) && (<div><a href={'http://'+this.props.companyWebsite} className="affiliate-member-website" target="_blank">{this.props.companyWebsite}</a></div>)}
          </div>
        </div>

        <div className="affiliate-member-bio">
        
          {(this.props.bio !== null) && 
            (this.props.bio)
          }
        </div>
      </section>
    )
  }
}

export default DirectoryListing;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/affiliate-directory/directory-listing.tsx